import React from 'react';
import { useHelixUIMode, useViewerScoreBand } from 'utils/helix';
import PercentageDisc from 'components/PercentageDisc';
import ScoreBandDonut from 'components/ScoreBandDonut';

/*
 * The disc beside a Helix score, as the viewer sees it: the score ringed in its band's colour
 * when scores are shown, a donut filled to the band's position when only bands are shown, or
 * `fallback` when there's nothing to show.
 */
import { jsx as _jsx } from "react/jsx-runtime";
function HelixScoreDisc(_ref) {
  var score = _ref.score,
    _ref$decimalPlaces = _ref.decimalPlaces,
    decimalPlaces = _ref$decimalPlaces === void 0 ? 0 : _ref$decimalPlaces,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'big' : _ref$size,
    _ref$showEmpty = _ref.showEmpty,
    showEmpty = _ref$showEmpty === void 0 ? false : _ref$showEmpty,
    _ref$fallback = _ref.fallback,
    fallback = _ref$fallback === void 0 ? null : _ref$fallback;
  var _useHelixUIMode = useHelixUIMode(),
    showScores = _useHelixUIMode.showScores,
    scoresNormalisedToBands = _useHelixUIMode.scoresNormalisedToBands,
    scoreBands = _useHelixUIMode.scoreBands,
    scoreOutOf = _useHelixUIMode.scoreOutOf;
  var hasScore = score !== undefined && score !== null;
  var band = useViewerScoreBand(score);
  if (scoresNormalisedToBands) {
    // The score is its band's position, so it fills that share of the donut
    return band && hasScore ? /*#__PURE__*/_jsx(ScoreBandDonut, {
      size: size,
      colour: band.colour,
      position: score,
      bandCount: scoreBands.length,
      icon: "asset-activity"
    }) : fallback;
  }
  if (showScores && (hasScore || showEmpty)) {
    return /*#__PURE__*/_jsx(PercentageDisc, {
      shady: true,
      size: size,
      percentage: hasScore ? score : undefined,
      outOf: scoreOutOf,
      decimalPlaces: decimalPlaces,
      ringColour: band === null || band === void 0 ? void 0 : band.colour
    });
  }
  return fallback;
}
export default HelixScoreDisc;